<template>
  <div>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="visible"
      :lock-scroll="false"
      title="新增模型"
      @close="close(false)"
    >
      <el-form :model="modelForm" :rules="modelFormRules" ref="modelForm" label-width="150px">
        <el-form-item label="模型序号" prop="orderNumber">
          <el-input
            v-model="modelForm.orderNumber"
            placeholder="请输入序号"
            size="small"
            oninput="value = value.replace(/[^\d.]/g,'')"
            clearable
          />
        </el-form-item>
        <el-form-item label="模型分类" prop="directoryId">
          <el-select
            ref="modelTree"
            v-model="modelForm.modelClassName"
            class="mr-10px w-200px"
            popper-class="document_select-popper select-tree"
            :popper-append-to-body="false"
            placeholder="请选择模型分类"
            clearable
            filterable
          >
            <el-option
              v-for="item in flatTreeData"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              class="hidden"
            ></el-option>
            <el-tree
              ref="modelClassTree"
              :data="treeData"
              :props="{
                children: 'children',
                label: 'name',
              }"
              :expand-on-click-node="false"
              @node-click="treeNodeClick"
              node-key="id"
              highlight-current
            ></el-tree>
          </el-select>
        </el-form-item>
        <el-form-item label="模型名称" prop="name">
          <el-input
            v-model.trim="modelForm.name"
            placeholder="请输入模型名称"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item label="模型标签" prop="lables">
          <div class="max-w-440px flex justify-start flex-wrap">
            <el-tag
              class="h-36px mr-10px mb-10px mt-2px flex items-center text-14px"
              v-for="tag in modelForm.lables"
              @close="handleClose(tag)"
              :key="tag"
              :disable-transitions="false"
              closable
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="!w-84px"
              v-if="inputVisible"
              v-model.trim="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="my-2px inline-block" size="small" @click="showInput"
              >+新标签</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="save()">保存</el-button>
        <el-button size="small" @click="close(false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ModelDirectoryApi, ModelApi } from '@wiz-api/material-management'

const modelDirectoryApi = new ModelDirectoryApi()
const modelApi = new ModelApi()

export default {
  name: 'MergeSceneFile',
  components: {},
  props: {
    // 弹框显隐
    visible: {
      type: Boolean,
      defalut: false,
    },
    mediaTypes: {
      type: Array,
      defalut: () => {
        return []
      },
    },
  },
  data() {
    return {
      // 表单校验规则
      modelFormRules: {
        orderNumber: [
          {
            required: true,
            message: '请输入模型序号',
            trigger: 'blur',
          },
        ],
        directoryId: [
          {
            required: true,
            message: '请选择模型分类',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入模型名称',
            trigger: 'blur',
          },
        ],
      },
      // 表单
      modelForm: {
        modelClassName: '',
        name: '',
        orderNumber: '',
        directoryId: '',
        lables: [],
      },
      // 查看屏蔽标签新增
      inputVisible: false,
      // 输入框内容
      inputValue: '',
      flatTreeData: [],
      treeData: [],
    }
  },
  methods: {
    // 获取模型树
    async getTreeData() {
      const [err, res] = await modelDirectoryApi.getTree()
      if (!err && !_.isNil(res)) {
        this.flatTreeData = this.transformList(res)
        this.treeData = [{ name: '根目录', id: '', children: res }]
      }
    },
    // 扁平化模型树
    transformList(data, resultList = []) {
      if (!_.isArray(data)) {
        return []
      }
      _.forEach(data, (node) => {
        resultList.push(_.pick(node, ['id', 'name', 'path']))
        this.transformList(node.children, resultList)
      })
      return resultList
    },
    // 下拉数形点击
    treeNodeClick(node) {
      this.modelForm.directoryId = node.id
      this.modelForm.modelClassName = node.path
      this.$refs.modelTree.blur()
    },
    // 标签删除
    handleClose(tag) {
      if (!_.isArray(this.modelForm.lables)) {
        return
      }
      this.modelForm.lables.splice(_.indexOf(this.modelForm.lables, tag), 1)
    },
    // 标签添加聚焦
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 新增标签校验
    handleInputConfirm() {
      if (_.includes(this.modelForm.lables, this.inputValue)) {
        this.$message.warning('已存在该标签')
        return
      }
      if (_.get(this.modelForm.lables, 'length') > 20) {
        this.$message.warning('标签数量已超过最大限制')
        return
      }
      if (this.inputValue) {
        this.modelForm.lables.push(this.inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 关闭弹框事件
    close(isSave) {
      this.$emit('close', isSave)
    },
    // 表单保存
    save() {
      this.$refs.modelForm.validate(async (valid) => {
        if (valid) {
          const params = _.pick(this.modelForm, ['name', 'orderNumber', 'directoryId', 'lables'])
          const body = {
            ...params,
            medias: this.mediaTypes,
          }
          const [err] = await modelApi.create({
            body,
          })
          if (!err) {
            this.$message.success('新增模型成功')
            this.close(true)
          }
        }
      })
    },
  },
  created() {
    this.getTreeData()
  },
}
</script>
<style lang="scss">
@import '../../assets/style/select';

.select-tree .el-select-dropdown__item {
  height: unset !important;
  line-height: unset !important;
}

.select-tree .el-tree-node__label {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../assets/style/index';

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
  background-color: transparent !important;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 5px !important;
}
</style>
